import { TsDOM as q } from '@/scripts/core/TsDOM'
import { UcoastEl } from '@/scripts/core/UcoastEl'

export class SidebarFacets extends UcoastEl {
  static htmlSelector = 'sidebar-facets'

  inputs: NodeListOf<HTMLInputElement>

  constructor() {
    super()

    this.inputs = q.rl('input', this)
    this.inputs.forEach(input => {
      input.addEventListener('change', this.onChangeFilter.bind(this))
    })
  }

  onChangeFilter(e: Event) {
    const target = e.currentTarget as HTMLInputElement
    if(!target) return
    if(target.value == '') this.inputs.forEach(input => input.checked = false)
    const facetForm = document.querySelector('[data-uc-facet-form]') as HTMLFormElement
    if (!facetForm) return
    facetForm.querySelector('.mobile-facets__checkbox')?.dispatchEvent(new InputEvent('input', { bubbles: true }))
  }
}


export class FacetSort extends UcoastEl {
  static htmlSelector = 'facet-sort'

  select: HTMLSelectElement

  constructor() {
    super()

    this.select = q.rs('select', this)
    this.select.addEventListener('change', this.onChangeFilter.bind(this))
  }

  onChangeFilter(e: Event) {
    const sortInputs = document.querySelectorAll('.facets-sort__input') as NodeListOf<HTMLInputElement> | null
    if (!sortInputs) return
    sortInputs.forEach(sort => {
      sort.checked = sort.value == this.select.value
    })
    const facetForm = document.querySelector('[data-uc-facet-form]') as HTMLFormElement
    if (!facetForm) return
    facetForm.querySelector('.mobile-facets__checkbox')?.dispatchEvent(new InputEvent('input', { bubbles: true }))
  }
}
